interface CategoryFilterProps {
  categories: { key: string; label: string }[];
  activeCategory: string;
  onCategoryChange: (key: string) => void;
}

export default function CategoryFilter({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {categories.map((cat) => (
        <button
          key={cat.key}
          type="button"
          onClick={() => onCategoryChange(cat.key)}
          className={`whitespace-nowrap font-label text-sm font-medium px-4 py-2 rounded-full transition-all duration-200 cursor-pointer ${
            activeCategory === cat.key
              ? 'bg-accent-500 text-foreground-950'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
          }`}
        >
          {cat.label}
        </button>
      ))}
    </div>
  );
}